import React from 'react';
import { observer } from 'mobx-react-lite';
import decline from 'utils/decline';

const SeatsCount = observer(({ seatsCount, isPurchase }) => {
  if (!seatsCount) return null;

  const declineForms = isPurchase ? ['места', 'мест', 'мест'] : ['место', 'места', 'мест'];

  return (
    <tr>
      <td className="pale">Вместим.</td>
      <td>
        <span className="bold">
          {isPurchase && 'от '}
          {seatsCount} {decline(seatsCount, declineForms)}
        </span>
      </td>
    </tr>
  );
});

export default SeatsCount;
